export const colors = {
  red: "#ff3246",
  transparent_red: "rgba(255, 50, 70, 0.05)",
  dark_red: "#DC0029",
  light_red: "#FFEAE9",
  blue: "#28aaff",
  violet: "#5551FF",
  transparent_violet: "rgba(85, 81, 255, 0.05)",
  green: "#1ed25a",
  light_green: "#E2FAE4",
  dark_green: "#00851D",
  light_blue: "rgba(40, 170, 255, 0.10)",
  yellow: "#ffd200",
  purple: "#aa32dc",
  grey: "#E2E2E2",
  black: "#353535",
  orange: "#FF7828",
  transparent_orange: "rgba(255, 120, 40, 0.05)",
  te: "rgba(0,0,0,0.38)",
  ff: "rgba(0,0,0,0.54)",
  es: "rgba(0,0,0,0.87)",
};
